import { Children, isValidElement } from "react";

import { TableItem as Container } from "./styles";

/**
 * Texto puro de um nó React, para usar como tooltip. Só desce por elementos
 * simples; se a célula tiver um componente de verdade dentro (badge, botão),
 * devolve vazio e nenhum title é posto.
 */
function textoDe(node) {
  if (node === null || node === undefined || typeof node === "boolean") return "";
  if (typeof node === "string" || typeof node === "number") return String(node);
  if (Array.isArray(node)) return node.map(textoDe).join("");
  if (isValidElement(node)) return Children.toArray(node.props?.children).map(textoDe).join("");
  return "";
}

export function TableItem({ children, title, ...rest }) {
  // nome comprido é cortado com reticências; o title devolve o valor inteiro
  // ao passar o mouse. Um title explícito tem prioridade.
  const tooltip = title ?? (textoDe(children).trim() || undefined);

  return (
    <Container {...rest}>
      <span title={tooltip}>{children}</span>
    </Container>
  );
}
